export const chartColumns = () => {
  return [
    {
      field: 'goodsType', //
      title: '货物类型',
      width: '150',
      editRender: { name: 'goodsType' },
    },
    {
      field: 'goodsCategory', //
      title: '货物品类',
      width: '140',
      editRender: { name: 'goodsCategory' },
    },
    {
      field: 'goodsModel',
      title: '规格型号',
      width: '140',
      // editRender: { name: 'input' },
    },
    {
      field: 'goodsPlace',
      title: '产地',
      width: '140',
      // editRender: { name: 'input' },
    },
    {
      field: 'measureMethod',
      title: '计量方式',
      width: '140',
      editRender: { name: 'measureMethod' },
    },
    {
      field: 'quantity',
      title: '重量/数量',
      width: '140',
      editRender: { name: 'quantity' },
    },
    {
      field: 'unit',
      title: '单位',
      width: '140',
      editRender: { name: 'unit' },
    },
    {
      field: 'initSafeWeight',
      title: '安全重量/数量',
      width: '140',
      editRender: { name: 'initSafeWeight' },
    },
    {
      field: 'safeWeight',
      title: '实际安全重量/数量',
      width: '140',
      // editRender: { name: 'safeWeight' },
    },
    {
      field: 'trademark',
      title: '商标',
      width: '140',
      editRender: { name: 'input' },
    },
    {
      field: 'pack',
      title: '包装',
      width: '140',
      // editRender: { name: 'input' },
    },
    {
      field: 'packCategory', //
      title: '包装类别',
      width: '140',
      editRender: { name: 'input' },
    },
    {
      field: 'remark',
      title: '备注',
      width: '140',
      editRender: { name: 'input' },
    },
  ];
};
